export default __webpack_public_path__ + "static/media/greyIIcon.44c58c3d.svg";